import { ValueRendererProps } from "./types";

const ValueRenderer = ({ value, renderer }: ValueRendererProps) => {
  if (renderer) {
    return renderer(value);
  }
  return value;
};

export default ValueRenderer;
